import { api } from "#convex/_generated/api.js";
import { useQuery } from "convex/react";

export type UnreadMessage = {
  _id: string;
  msgUnread: number;
  teUnread: number;
}

export function StrandedUnreadBadge() {
  const strandedUsers = useQuery(api.user.getStrandedUsers)

  if(strandedUsers == null) {
    return <></>
  }
  
  return (
    <>
      {strandedUsers.length > 0 && (
        <div className="bg-danger w-7 h-7 border-white border rounded-full relative z-0 items-center justify-center flex">
        <div className="bg-danger w-5 h-5 border-white border rounded-full relative z-0">
          <div className="absolute inset-0 flex justify-center items-center z-10">
            <p className="text-sm font-bold text-white">{strandedUsers.length}</p>
          </div>
        </div>
      </div>
      )}
    </>
  )
}
